import { getGAIdAsync } from './StoreConfigManager.js';
import { getObsessLocaleFormat } from '../../i18n/locales/utils.js';

const missedVirtualPagePaths = [];
const missedEvents = [];
let storeName = '';

export function setStoreName(name) {
    storeName = name;
}

export function sendMissedAnalyticsOnGALoaded(id) {
    missedVirtualPagePaths.forEach(element => {
        console.log('sending missed virtual page paths', element);
        window.gtag('config', id, { 'page_path': element });
    });

    missedEvents.forEach(element => {
        console.log('sending missed events', element);
        const category = element['event_category'];
        const action = element['event_action'];
        const label = element['event_label'];
        window.gtag('event', 'play', {
            'event_category': category,
            'event_action': action,
            'event_label': label
        });
    });
}

const AtLeastOnce = {
    EventCategory: 'At least once',
    Props: {
        MovedOnce: {
            EventAction: 'Moved once',
            EventLabel: 'Moved once',
            called: false
        },
        ProductHotspotOnce: {
            EventAction: 'Product hotspot once',
            EventLabel: 'Product hotspot once',
            called: false
        },
        BuyNowOnce: {
            EventAction: 'Buy now once',
            EventLabel: 'Buy now once',
            called: false
        },
        InteractedOnce: {
            EventAction: 'Interacted once',
            EventLabel: 'Interacted once',
            called: false
        }
    }
}

const Navigation = {
    EventCategory: 'Navigation',
    Props: {
        SceneLoaded: {
            EventAction: 'Scene loaded',
            EventLabel: ''
        },
        ArrowClicked: {
            EventAction: 'Arrow clicked',
            EventLabel: ''
        },
        NavigationMenuClicked: {
            EventAction: 'Navigation menu clicked',
            EventLabel: ''
        },
        BottomBarMenuClicked: {
            EventAction: 'Bottom bar menu click',
            EventLabel: ''
        }
    }
}

const Product = {
    EventCategory: 'Product',
    Props: {
        ProductHotspotClicked: {
            EventAction: 'Product hotspot clicked',
            EventLabel: '<Product name> - <SKU>'
        },
        BuyNowClicked: {
            EventAction: 'Buy now clicked',
            EventLabel: '<Product name> - <SKU>'
        },
        AddedProductToFavorite: {
            EventAction: 'Favorite added',
            EventLabel: '<Product name> - <SKU>'
        },
        RemovedProductFromFavorite: {
            EventAction: 'Favorite removed',
            EventLabel: '<Product name> - <SKU>'
        },
        SpinActivated: {
            EventAction: 'Spin Activated',
            EventLabel: '<Product name> - <SKU>'
        },
        ColorSelectorActivated: {
            EventAction: 'Color selector activated',
            EventLabel: '<Product name> - <SKU>'
        },
        ColorSelectorOptionClicked: {
            EventAction: 'Color selector option clicked',
            EventLabel: '<Product name> - <Product color>'
        },
        AddToWishlistClicked: {
            EventAction: 'Wishlist Icon clicked ',
            EventLabel: '<Product name> - <SKU>'
        },
        DetailsClicked: {
            EventAction: 'Details clicked',
            EventLabel: '<Product name> - <SKU>'
        },
        ThumbnailClicked: {
            EventAction: 'Thumbnail clicked',
            EventLabel: '<Product name> - <SKU>'
        },
        VideoIconClicked: {
            EventAction: 'Video icon clicked',
            EventLabel: '<Product name> - <SKU>'
        },
        AddToBagClicked: {
            EventAction: 'Add to bag clicked',
            EventLabel: '<Product name> - <SKU>'
        },
        ShowProductDetailsClicked: {
            EventAction: 'Product Details clicked',
            EventLabel: 'ProductDetail'
        },
        QuantityIncClick: {
            EventAction: 'Quantity Add clicked',
            EventLabel: 'Quantity Add'
        },
        QuantityDecClick: {
            EventAction: 'Quantity Minus clicked',
            EventLabel: 'Quantity Minus'
        },
        CuratedProductClicked: {
            EventAction: 'Curated For You clicked',
            EventLabel: '<Product name> - <SKU>'
        },
    }
}

const Other = {
    EventCategory: 'Other',
    Props: {
        LogoClicked: {
            EventAction: 'Logo clicked',
            EventLabel: 'Logo clicked'
        },
        WelcomeTipsDismissed: {
            EventAction: 'Welcome tips dismissed',
            EventLabel: 'Welcome tips dismissed'
        },
        MusicButton: {
            EventAction: 'Music button',
            EventLabel: 'on / off'
        },
        FacebookButton: {
            EventAction: 'Facebook button',
            EventLabel: 'Facebook button'
        },
        TwitterButton: {
            EventAction: 'Twitter button',
            EventLabel: 'Twitter button'
        },
        WhatsAppButton: {
            EventAction: 'Social share whatsapp clicked',
            EventLabel: 'Social share whatsapp clicked'
        },
        WhatsAppWishlistButton: {
            EventAction: 'Wishlist WhatsApp clicked',
            EventLabel: 'Wishlist WhatsApp clicked'
        },
        WhatsAppCartButton: {
            EventAction: 'Cart WhatsApp clicked',
            EventLabel: 'Cart WhatsApp clicked'
        },
        ObsessLogo: {
            EventAction: 'Obsess logo',
            EventLabel: 'Obsess logo'
        },
        BrandLogo: {
            EventAction: 'Brand logo',
            EventLabel: 'Brand logo'
        },
        Email: {
            EventAction: 'Wishlist Email clicked',
            EventLabel: 'Wishlist Email clicked'
        },
        StoreSelectorIcon: {
            EventAction: 'Store selector icon clicked',
            EventLabel: ''
        },
        StoreSelectorOption: {
            EventAction: 'Store selector option clicked',
            EventLabel: '<store name>'
        },
        WishlistIconClicked: {
            EventAction: 'Wishlist icon clicked',
            EventLabel: '<Scene slug>'
        },
        QuizStoreSelectorClick: {
            EventAction: 'Store Selector Option clicked',
            EventLabel: 'Start Quiz - Section Selector'
        },
        LegendStoreSelectorClick: {
            EventAction: 'Store Selector Option clicked',
            EventLabel: 'Legend clicked'
        },
        TopWishlistIconClicked: {
            EventAction: 'Wishlist icon clicked',
            EventLabel: 'Wishlist icon clicked'
        },
        TopBagIconClicked: {
            EventAction: 'Bag icon clicked',
            EventLabel: 'Bag icon clicked'
        },
        WishlistShareButtonClicked: {
            EventAction: 'Wishlist Share clicked',
            EventLabel: 'Wishlist Share clicked'
        },
        WishlistCheckoutButtonClicked: {
            EventAction: 'WishlistCheckout clicked',
            EventLabel: 'WishlistCheckout clicked'
        },
        BagCheckoutButtonClicked: {
            EventAction: 'Bag Checkout clicked',
            EventLabel: 'Bag Checkout clicked'
        },
        LinkedInClicked: {
            EventAction: 'LinkedIn clicked',
            EventLabel: 'LinkedIn clicked'
        },
        CopyLinkClicked: {
            EventAction: 'Link Copied clicked',
            EventLabel: 'Link Copied clicked'
        },
        EmailClicked: {
            EventAction: 'Email clicked',
            EventLabel: 'Email clicked'
        },
        LiveChatButtonClicked: {
            EventAction: 'Live chat button clicked',
            EventLabel: 'Live chat button clicked'
        }
    }
}

const Content = {
    EventCategory: 'Content',
    Props: {
        InSceneVideoClicked: {
            EventAction: 'In-scene video',
            EventLabel: '<video name>'
        },
        PopupVideoClicked: {
            EventAction: 'Pop-up video',
            EventLabel: '<video name>'
        },
        ImageClicked: {
            EventAction: 'Image',
            EventLabel: '<image name>'
        },
        TextClicked: {
            EventAction: 'Text',
            EventLabel: ''
        },
        LinkClicked: {
            EventAction: 'Link',
            EventLabel: '<target url>'
        },
        TextPopUpHotSpotClicked: {
            EventAction: 'Text hotspot clicked',
            EventLabel: 'Text hotspot clicked'
        },
        TextPopUpButtonClicked: {
            EventAction: 'Text pop-up button clicked',
            EventLabel: '<store name> - <view name>'
        },
        ImageHotspotClicked: {
            EventAction: 'Image hotspot clicked',
            EventLabel: 'Image hotspot clicked'
        },
        ImageCarouselHotspotClicked: {
            EventAction: 'Image carousel hotspot clicked',
            EventLabel: 'Image carousel hotspot clicked',
        },
        ImageHotspotCTAClicked: {
            EventAction: 'Image hotspot CTA clicked',
            EventLabel: '<Image hotspot tittle> CTA clicked'
        }
    }
}

const Quiz = {
    EventCategory: 'Quiz',
    Props: {
        QuizMarkerClicked: {
            EventAction: 'Quiz Hotspot Clicked',
            EventLabel: 'Quiz Hotspot'
        },
        QuizStartClicked: {
            EventAction: 'Quiz Start Clicked',
            EventLabel: 'Start Quiz'
        },
        QuizAnswerClicked: {
            EventAction: 'Quiz answer',
            EventLabel: 'Quiz answer'
        },
        QuizViewMoreClicked: {
            EventAction: 'Results - View more details clicked',
            EventLabel: 'View more details clicked'
        },
        QuizExitClicked: {
            EventAction: 'Quiz "x" Clicked',
            EventLabel: ' Exit Quiz'
        },
    }
}

function sendUserAction(eventCategory, eventAction, eventLable) {
    if (!window.gtag) {
        console.log('no gtag');
        const missedEvent = {
            'event_category': eventCategory,
            'event_action': eventAction,
            'event_label': storeName + ' - ' + eventLable
        };
        missedEvents.push(missedEvent)
        return;
    }
    window.gtag('event', 'play', {
        'event_category': eventCategory,
        'event_action': eventAction,
        'event_label': storeName + ' - ' + eventLable
    });
    // var analytics = window.analytics;
    // analytics.track(eventAction, {
    //     'category': eventCategory,
    //     'action': eventAction,
    //     'label': storeName + ' ' + eventLable
    // });
}

// At Least Once
export function MovedOnce() {
    let prop = AtLeastOnce.Props.MovedOnce;
    if (prop.called) {
        return;
    }
    prop.called = true;
    sendUserAction(AtLeastOnce.EventCategory, prop.EventAction, prop.EventLabel);
}

export function ProductHotspotOnce() {
    let prop = AtLeastOnce.Props.ProductHotspotOnce;
    if (prop.called) {
        return;
    }
    prop.called = true;
    sendUserAction(AtLeastOnce.EventCategory, prop.EventAction, prop.EventLabel);
}

export function BuyNowOnce() {
    let prop = AtLeastOnce.Props.BuyNowOnce;
    if (prop.called) {
        return;
    }
    prop.called = true;
    sendUserAction(AtLeastOnce.EventCategory, prop.EventAction, prop.EventLabel);
}

export function InteractedOnce() {
    let prop = AtLeastOnce.Props.InteractedOnce;
    if (prop.called) {
        return;
    }
    prop.called = true;
    sendUserAction(AtLeastOnce.EventCategory, prop.EventAction, prop.EventLabel);
}

// Navigation
export function NavigationMenuClicked(sceneName) {
    let prop = Navigation.Props.NavigationMenuClicked;
    let eventLabel = sceneName;
    sendUserAction(Navigation.EventCategory, prop.EventAction, eventLabel);
}

export function BottomBarMenuClicked(sceneName) {
    let prop = Navigation.Props.BottomBarMenuClicked;
    let eventLabel = sceneName;
    sendUserAction(Navigation.EventCategory, prop.EventAction, eventLabel + ' clicked');
}

export function SceneLoaded(sceneId) {
    console.log('sceneloaded', sceneId);
    let prop = Navigation.Props.SceneLoaded;
    sendUserAction(Navigation.EventCategory, prop.EventAction, prop.EventLabel + sceneId);
}

export function ArrowClicked(destinationSceneId) {
    let prop = Navigation.Props.ArrowClicked;
    sendUserAction(Navigation.EventCategory, prop.EventAction, prop.EventLabel + destinationSceneId);
}

// Product
export function ProductHotspotClicked(sku, productName) {
    console.log('Product hotspot clicked:', productName, sku);
    let prop = Product.Props.ProductHotspotClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, productName + ' - ' + sku);
}

export function BuyNowClicked(sku, productName) {
    console.log('Buy now clicked:', productName, sku);
    let prop = Product.Props.BuyNowClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, productName + ' - ' + sku);
}

export function SpinActivated(sku, productName) {
    console.log('Spin Activated:', productName, sku);
    let prop = Product.Props.SpinActivated;
    sendUserAction(Product.EventCategory, prop.EventAction, productName + ' - ' + sku);
}

export function ColorSelectorActivated(sku, productName) {
    let prop = Product.Props.ColorSelectorActivated;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${sku}`)
}

export function ColorSelectorOptionClicked(productColor, productName) {
    let prop = Product.Props.ColorSelectorOptionClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${productColor}`)
}

export function AddedHeartItem(sku, productName) {
    let prop = Product.Props.AddedProductToFavorite;
    sendUserAction(Product.EventCategory, prop.EventAction, productName + ' - ' + sku);
}

export function RemovedHeartItem(sku, productName) {
    let prop = Product.Props.RemovedProductFromFavorite;
    sendUserAction(Product.EventCategory, prop.EventAction, productName + ' - ' + sku);
}

export function AddToWishlistClicked(sku, productName) {
    console.log('Add to wishlist clicked:', productName, sku);
    let prop = Product.Props.AddToWishlistClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, "Wishlist_" + productName + ' - ' + sku);
}

export function AddToBagClicked(sku, productName) {
    let prop = Product.Props.AddToBagClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${sku}`);
}

export function DetailsClicked(sku, productName) {
    let prop = Product.Props.DetailsClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${sku}`);
}

export function ThumbnailClicked(sku, productName) {
    let prop = Product.Props.ThumbnailClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${sku}`);
}

export function VideoIconClicked(sku, productName) {
    let prop = Product.Props.VideoIconClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${sku}`);
}

// Other
export function LogoClicked() {
    let prop = Other.Props.LogoClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function WelcomeTipsDismissed() {
    let prop = Other.Props.WelcomeTipsDismissed;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function MusicButton(isOn) {
    let eventLabel = isOn ? 'on' : 'off';
    let prop = Other.Props.MusicButton;
    sendUserAction(Other.EventCategory, prop.EventAction, eventLabel);
}

export function FacebookButtonAnalytics() {
    let prop = Other.Props.FacebookButton;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function TwitterButtonAnalytics() {
    let prop = Other.Props.TwitterButton;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function WhatsAppButtonAnalytics() {
    let prop = Other.Props.WhatsAppButton;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function WhatsAppWishlistButtonAnalytics() {
    let prop = Other.Props.WhatsAppWishlistButton;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function WhatsAppCartButtonAnalytics() {
    let prop = Other.Props.WhatsAppCartButton;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function ObsessLogo() {
    let prop = Other.Props.ObsessLogo;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function BrandLogo() {
    let prop = Other.Props.BrandLogo;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function Email() {
    let prop = Other.Props.Email;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function StoreSelectorIcon() {
    let prop = Other.Props.StoreSelectorIcon;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function StoreSelectorOption(storeName) {
    let prop = Other.Props.StoreSelectorOption;
    sendUserAction(Other.EventCategory, prop.EventAction, storeName);
}

export function WishlistIconClicked(currentScene) {
    let prop = Other.Props.WishlistIconClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, currentScene);
}

export function TopWishlistIconClicked(currentScene) {
    let prop = Other.Props.TopWishlistIconClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function TopBagIconClicked(currentScene) {
    let prop = Other.Props.TopBagIconClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function TextPopUpButtonClicked(viewName) {
    let prop = Content.Props.TextPopUpButtonClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, `${storeName} - ${viewName}`);
}

export function QuizStoreSelectorClick() {
    let prop = Other.Props.QuizStoreSelectorClick;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function LegendStoreSelectorClick() {
    let prop = Other.Props.LegendStoreSelectorClick;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function LiveChatButtonClicked() {
    let prop = Other.Props.LiveChatButtonClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}


// Media
export function InSceneVideoClicked(name) {
    let prop = Content.Props.InSceneVideoClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, name);
}

export function PopupVideoClicked(name) {
    let prop = Content.Props.PopupVideoClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, name);
}

export function ImageClicked(name) {
    let prop = Content.Props.ImageClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, name);
}

export function ImageHotspotClicked(title) {
    let prop = Content.Props.ImageHotspotClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, `${prop.EventLabel} - ${title}`);
}

export function ImageCarouselHotspotClicked(sceneName) {
    let prop = Content.Props.ImageCarouselHotspotClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, `${prop.EventLabel} - ${sceneName}`);
}

export function TextPopUpHotSpotClicked(sceneName) {
    let prop = Content.Props.TextPopUpHotSpotClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, `${prop.EventLabel} - ${sceneName}`);
}

export function TextClicked(title) {
    let prop = Content.Props.TextClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, title);
}

export function LinkClicked(targetUrl) {
    let prop = Content.Props.LinkClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, targetUrl);
}

export function QuizMarkerClicked(currentSceneName) {
    let prop = Quiz.Props.QuizMarkerClicked;
    sendUserAction(Quiz.EventCategory, prop.EventAction, `Quiz Hotspot - ${currentSceneName}`);
}

export function QuizStartClicked() {
    let prop = Quiz.Props.QuizStartClicked;
    sendUserAction(Quiz.EventCategory, prop.EventAction, prop.EventLabel);
}

export function QuizAnswerClicked(selectedAnswer) {
    let prop = Quiz.Props.QuizAnswerClicked;
    sendUserAction(Quiz.EventCategory, prop.EventAction, `Quiz answer - ${selectedAnswer}`);
}

export function QuizViewMoreClicked(sku) {
    let prop = Quiz.Props.QuizViewMoreClicked;
    sendUserAction(Quiz.EventCategory, prop.EventAction, `${prop.EventLabel} - ${sku}`);
}

export function QuizExitClicked() {
    let prop = Quiz.Props.QuizExitClicked;
    sendUserAction(Quiz.EventCategory, prop.EventAction, prop.EventLabel);
}

export function WishlistShareButtonClicked() {
    let prop = Other.Props.WishlistShareButtonClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function WishlistCheckoutButtonClicked() {
    let prop = Other.Props.WishlistCheckoutButtonClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function BagCheckoutButtonClicked() {
    let prop = Other.Props.BagCheckoutButtonClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function QuantityIncClick(title, sku) {
    let prop = Product.Props.QuantityIncClick;
    console.log('---------------- clicked -------------------')
    console.log(`${title} - ${sku}`)
    sendUserAction(Product.EventCategory, prop.EventAction, `${title} - ${sku}`);
}

export function QuantityDecClick(title, sku) {
    let prop = Product.Props.QuantityDecClick;
    console.log('---------------- clicked -------------------')
    console.log(`${title} - ${sku}`)
    sendUserAction(Product.EventCategory, prop.EventAction, `${title} - ${sku}`);
}

export function ShowProductDetailsClicked(title, sku) {
    let prop = Product.Props.ShowProductDetailsClicked;
    console.log('---------------- clicked -------------------')
    console.log(`${title} - ${sku}`)
    sendUserAction(Product.EventCategory, prop.EventAction, `${title} - ${sku}`);
}

export function LinkedInClicked() {
    let prop = Other.Props.LinkedInClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function CopyLinkClicked() {
    let prop = Other.Props.CopyLinkClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function EmailClicked() {
    let prop = Other.Props.EmailClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function CuratedProductClicked(name, sku) {
    let prop = Product.Props.CuratedProductClicked;
    console.log('---------------- clicked -------------------')
    console.log(`${name} - ${sku}`)
    sendUserAction(Product.EventCategory, prop.EventAction, `${name} - ${sku}`);
}

export function ImageHotspotCTAClicked(title) {
    let prop = Content.Props.ImageHotspotCTAClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, `${title} CTA clicked}`);
}

// Page
export function VirtualPageVisited(pageUri,currentLanguage) {
    if (!window.gtag) {
        console.log('no gtag');
        const path = storeName + '/' + pageUri;
        missedVirtualPagePaths.push(path);
        return;
    }
    const localeParam = getObsessLocaleFormat(currentLanguage);
    getGAIdAsync()
    .then(id => {
        console.log('virtual page visited', pageUri);
        console.log('sending ga to', id);
        // window.gtag('config', id, { 'page_path': '/main/' + pageUri });
        window.gtag('config', id, { 'page_path': storeName + `/${localeParam}/` + pageUri });
    })
    .catch(error => console.error(error));
}
